import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import CircleButton from "./../../Components/Buttons/CircleButton";
import Logo from "./../../Components/Logo";
import LanguageButtons from "./../../Components/Shared/LanguageButtons";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import FlexLeftPanel from "./../../Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./../../Components/Shared/PanelElements/FlexRightPanel";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme } from "@mui/material/styles";

import { Dlog } from "./../../../../utils/Dlog";

import { getErrorTranslateID } from "./../../HelperFunctions/ErrorDisplayFunctions";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { useNavigate } from "react-router-dom";

let env = require("./../../../../env");

export default function HorizontalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    errorCode,
    isNotMobile,
    kioskkey,
    showLoginConfirmModal,
    loginLocationAddress,
    loginLocationCode,
    loginLocationName,
    loginWarning,
    warningSwitchFromName,
    warningSwitchFromCode,
    confirmLoginCancelFunc,
    confirmLoginAdvanceFunc,
    showVersionMismatchModal,
    setShowVersionMismatchModal,
    latestVersion
  } = props;

  const theme = useTheme();
  const kioskstyles = useKioskHorizontalStyles();

  const showLoginConfirmModalBoolean =
    showLoginConfirmModal && !showVersionMismatchModal;

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={kioskstyles.GridFullHeightFix}
    >
      <FlexLeftPanel isNotMobile={isNotMobile} colorOverwrite="orange">
        <div style={kioskstyles.flexLeftPanelContents}>
          <div style={kioskstyles.flexParentPanel}>
            <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
              <Logo />
            </div>
            <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
              <div></div>
            </div>
            <div style={kioskstyles.flexPanelLayoutB_BotContainer}>
              <LanguageButtons />
            </div>
          </div>
        </div>
      </FlexLeftPanel>
      <FlexRightPanel isNotMobile={isNotMobile}>
        <div style={kioskstyles.flexRightPanelContents}>
          <div style={kioskstyles.flexParentPanel}>
            <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
              <SubtitleWrapper isNotMobile={isNotMobile}>
                <Translate value="application.configuration.configuration" />
              </SubtitleWrapper>
            </div>
            {!showLoginConfirmModal && (
              <>
                <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
                  <Typography
                    variant="h5"
                    style={{
                      fontSize: "clamp(0.6rem, 2vw, 1.6rem)",
                      textAlign: "center"
                    }}
                  >
                    <Translate value="application.configuration.enterkey" />
                  </Typography>
                  <TextField
                    id="KioskKey"
                    label=""
                    value={kioskkey}
                    onChange={event => {
                      setKioskkeyFunc(event.target.value);
                    }}
                    sx={{
                      height: "10vh", // Scales with viewport height
                      "& .MuiInputBase-root": {
                        height: "100%" // Fill the container
                      },
                      "& .MuiInputBase-input": {
                        fontSize: "4vh", // Font scales with viewport height
                        textAlign: "center",
                        width: "15vw"
                      },
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white"
                      }
                    }}
                  />
                  <Typography
                    variant="body2"
                    class="fontSecondaryText"
                    style={{
                      color: "red",
                      marginTop: "4.4vh",
                      fontSize: "clamp(12px, 1.3vw, 20px)",
                      textAlign: "center"
                    }}
                  >
                    <Translate value={getErrorTranslateID(errorCode)} />
                  </Typography>

                  <div style={kioskstyles.flexPanelLayoutB_BotContainer}>
                    <Button
                      variant="contained"
                      disabled={loading}
                      onClick={nextFunc}
                      style={{
                        ...kioskstyles.textButtons,
                        marginBottom: "0px"
                      }}
                    >
                      <span class="fontSecondaryText">
                        <Translate value="application.next" />
                      </span>
                    </Button>
                  </div>
                </div>
              </>
            )}

            {showVersionMismatchModal && (
              <>
                <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-around",
                      textAlign: "center"
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "4vh", marginBottom: "4vh" }}>
                        <Translate value="application.configuration.versionmismatch" />
                      </div>

                      <div
                        style={{
                          fontSize: "2.5vh",
                          marginTop: "2vh",
                          fontStyle: "italic"
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          <Translate value="application.configuration.warning" />
                          :{" "}
                        </span>
                        <Translate
                          value="application.configuration.versionmismatchwarning"
                          latestversion={latestVersion}
                          currentversion={env.REACT_APP_VERSION}
                        />
                      </div>
                    </div>

                    <div>
                      <Button
                        variant="contained"
                        disabled={loading}
                        onClick={confirmLoginCancelFunc}
                        style={{
                          ...kioskstyles.textButtons,
                          color: "black",
                          backgroundColor: "white"
                        }}
                      >
                        <span className="fontSecondaryText">
                          <Translate value="application.back" />
                        </span>
                      </Button>
                      <Button
                        variant="contained"
                        disabled={loading}
                        onClick={() => setShowVersionMismatchModal(false)}
                        style={kioskstyles.textButtons}
                      >
                        <span className="fontSecondaryText">
                          <Translate value="application.continue" />
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
                <div style={kioskstyles.flexPanelLayoutB_BotContainer}></div>
              </>
            )}

            {showLoginConfirmModalBoolean && (
              <>
                <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
                  <div
                    style={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-around",
                      textAlign: "center"
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "4vh", marginBottom: "4vh" }}>
                        <Translate value="application.configuration.confirmlogginginas" />
                      </div>
                      <div style={{ fontSize: "5.5vh" }}>
                        {loginLocationCode}
                      </div>
                      <div style={{ fontSize: "5.5vh", marginBottom: "5.5vh" }}>
                        {loginLocationName}
                      </div>
                      <div style={{ fontSize: "4vh", marginBottom: "4vh" }}>
                        {loginLocationAddress}
                      </div>

                      {loginWarning && (
                        <>
                          <div
                            style={{
                              fontSize: "2.5vh",
                              marginTop: "2vh",
                              fontStyle: "italic"
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              <Translate value="application.configuration.warning" />
                              :{" "}
                            </span>
                            <Translate value="application.configuration.confirmchangecollectorwarning" />{" "}
                            {warningSwitchFromCode}
                            {", "}
                            {warningSwitchFromName}
                          </div>
                        </>
                      )}

                      {!loginWarning && (
                        <>
                          <div style={{ fontSize: "4vh", marginTop: "2vh" }}>
                            <Translate value="application.configuration.confirmisthiscorrect" />
                          </div>
                        </>
                      )}
                    </div>

                    <div>
                      <Button
                        variant="contained"
                        disabled={loading}
                        onClick={confirmLoginCancelFunc}
                        style={{
                          ...kioskstyles.textButtons,
                          color: "black",
                          backgroundColor: "white"
                        }}
                      >
                        <span className="fontSecondaryText">
                          <Translate value="application.no" />
                        </span>
                      </Button>
                      <Button
                        variant="contained"
                        disabled={loading}
                        onClick={confirmLoginAdvanceFunc}
                        style={kioskstyles.textButtons}
                      >
                        <span className="fontSecondaryText">
                          <Translate value="application.yes" />
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
                <div style={kioskstyles.flexPanelLayoutB_BotContainer}></div>
              </>
            )}
          </div>
        </div>
      </FlexRightPanel>
    </Grid>
  );
}
